/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTaskChangeRequestsBulkDto } from '../models/work-create-task-change-requests-bulk-dto';
import { WorkTaskChangeRequest } from '../models/work-task-change-request';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceTaskChangeRequestsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceTaskChangeRequestsV2ControllerCreate()` */
  static readonly SelfserviceTaskChangeRequestsV2ControllerCreatePath = '/v2/selfservice/task-change-requests';

  /**
   * Create task change requests.
   *
   * Creates one or more task change requests for a project (e.g. date change requests)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceTaskChangeRequestsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceTaskChangeRequestsV2ControllerCreate$Response(
    params: {
      body: WorkCreateTaskChangeRequestsBulkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTaskChangeRequest>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceTaskChangeRequestsService.SelfserviceTaskChangeRequestsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTaskChangeRequest>>;
      })
    );
  }

  /**
   * Create task change requests.
   *
   * Creates one or more task change requests for a project (e.g. date change requests)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceTaskChangeRequestsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceTaskChangeRequestsV2ControllerCreate(
    params: {
      body: WorkCreateTaskChangeRequestsBulkDto
    },
    context?: HttpContext
  ): Observable<Array<WorkTaskChangeRequest>> {
    return this.selfserviceTaskChangeRequestsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTaskChangeRequest>>): Array<WorkTaskChangeRequest> => r.body)
    );
  }

  /** Path part for operation `selfserviceTaskChangeRequestsV2ControllerFindByProjectId()` */
  static readonly SelfserviceTaskChangeRequestsV2ControllerFindByProjectIdPath = '/v2/selfservice/task-change-requests/project/{projectId}';

  /**
   * Get task change requests for a project.
   *
   * Returns all task change requests for a specific project
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceTaskChangeRequestsV2ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceTaskChangeRequestsV2ControllerFindByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTaskChangeRequest>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceTaskChangeRequestsService.SelfserviceTaskChangeRequestsV2ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTaskChangeRequest>>;
      })
    );
  }

  /**
   * Get task change requests for a project.
   *
   * Returns all task change requests for a specific project
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceTaskChangeRequestsV2ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceTaskChangeRequestsV2ControllerFindByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTaskChangeRequest>> {
    return this.selfserviceTaskChangeRequestsV2ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTaskChangeRequest>>): Array<WorkTaskChangeRequest> => r.body)
    );
  }

}
